module.exports = __webpack_public_path__ + "media/images/metronic/social/flickr-4ea39acb8b574abf4115eaa701923177.png";